import React from "react";
import bg from "../subscribe-bg.jpg";

const Newsletter = () => {
  return (
    <div>
      <section id="subscribe" className="" style={{
      backgroundImage: `url(${bg})`}}>
        <div className="container" data-aos="zoom-in">
          <div className="section-header">
            <h2>Newsletter</h2>
            <p>Stay Informed, Stay Inspired: Subscribe to Our Newsletter for the Latest Conference Insights and Innovations!</p>
          </div>

          <form>
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-10 d-flex">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your Email"
                />
                <button type="submit" className="ms-2">
                  Subscribe
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Newsletter;
